import React from "react";
import { colors } from "../shared/constants";
import { formatDayLabel } from "../shared/dateUtils";

// The run of inspection days, shared by the Calendar tab and the slot picker in
// the booking drawer so the two stay identical rather than merely similar.
// `compact` narrows it to fit the 420px drawer.
export function DateStrip({ days, active, onSelect, compact }) {
  return (
    <div
      style={{
        display: "flex",
        gap: "8px",
        overflowX: "auto",
        paddingBottom: compact ? "8px" : "12px",
        marginBottom: "4px",
      }}
    >
      {days.map((d) => {
        const on = d.date === active;
        const free = d.slot_count - d.assigned_count - (d.blocked_count || 0);
        return (
          <button
            key={d.date}
            onClick={() => onSelect(d.date)}
            style={{
              minWidth: compact ? "88px" : "104px",
              padding: compact ? "6px 10px" : "8px 12px",
              borderRadius: "8px",
              cursor: "pointer",
              textAlign: "left",
              flexShrink: 0,
              border: `1px solid ${on ? colors.darkGrey : colors.border}`,
              backgroundColor: on ? colors.darkGrey : colors.white,
              color: on ? colors.white : colors.text,
            }}
          >
            <div style={{ fontSize: compact ? "12px" : "13px", fontWeight: "600" }}>
              {formatDayLabel(d.date)}
            </div>
            <div
              style={{
                fontSize: "12px",
                marginTop: "2px",
                color: on ? "rgba(255,255,255,0.75)" : colors.slate,
              }}
            >
              {compact
                ? `${free} free`
                : `${d.assigned_count}/${d.slot_count} booked`}
            </div>
          </button>
        );
      })}
    </div>
  );
}
